import { render } from "./CardIcon.vue?vue&type=template&id=29980f92"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CardIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29980f92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29980f92', __exports__)) {
    api.reload('29980f92', __exports__)
  }
  
  module.hot.accept("./CardIcon.vue?vue&type=template&id=29980f92", () => {
    api.rerender('29980f92', render)
  })

}


export default __exports__